export const ROUTES = {
  Welcome: '/',
  Demo: '/demo/',
  Login: '/login',
  Mood_log_entry: '/mood-log-entry',
  Home_calendar: '/home/calendar',
  Home_log: '/home/log',
  Patches: '/patches',
  Profile: '/profile',
} as const;

export const SECTIONS = {
  Welcome: 'welcome',
  Demo: 'demo',
  Login: 'login',
  Mood_log_entry: 'mood-log-entry',
  Home: 'home',
  Patches: 'patches',
  Profile: 'profile',
  Unknown: 'unknown',
} as const;

export type Route = (typeof ROUTES)[keyof typeof ROUTES];
export type Section = (typeof SECTIONS)[keyof typeof SECTIONS];

export const sectionsHierarchy: Section[] = [
  SECTIONS.Welcome,
  SECTIONS.Demo,
  SECTIONS.Login,
  SECTIONS.Home,
  SECTIONS.Mood_log_entry,
  SECTIONS.Patches,
  SECTIONS.Profile,
  SECTIONS.Unknown,
] as const;
